import { createAction } from 'redux-actions';

export const getScheduledTransactions = createAction('GET_SCHEDULED_TRANSACTIONS');
export const getScheduledTransactionsSuccess = createAction('GET_SCHEDULED_TRANSACTIONS_SUCCESS');
export const getScheduledTransactionsFailure = createAction('GET_SCHEDULED_TRANSACTIONS_FAILURE');

export const createScheduledTransaction = createAction('CREATE_SCHEDULED_TRANSACTION', (payload) => payload, (payload, meta) => meta);
export const createScheduledTransactionSuccess = createAction('CREATE_SCHEDULED_TRANSACTION_SUCCESS', (payload) => payload, (payload, meta) => meta);
export const createScheduledTransactionFailure = createAction('CREATE_SCHEDULED_TRANSACTION_FAILURE');

export const updateScheduledTransaction = createAction('UPDATE_SCHEDULED_TRANSACTION', (payload) => payload, (payload, meta) => meta);
export const updateScheduledTransactionSuccess = createAction('UPDATE_SCHEDULED_TRANSACTION_SUCCESS');
export const updateScheduledTransactionFailure = createAction('UPDATE_SCHEDULED_TRANSACTION_FAILURE');

export const deleteScheduledTransaction = createAction('DELETE_SCHEDULED_TRANSACTION', (payload) => payload, (payload, meta) => meta);
export const deleteScheduledTransactionSuccess = createAction('DELETE_SCHEDULED_TRANSACTION_SUCCESS');
export const deleteScheduledTransactionFailure = createAction('DELETE_SCHEDULED_TRANSACTION_FAILURE');

export const createBillScoutSchedule = createAction('CREATE_BILLSCOUT_SCHEDULE', (payload) => payload, (payload, meta) => meta);
export const createBillScoutScheduleSuccess = createAction('CREATE_BILLSCOUT_SCHEDULE_SUCCESS', (payload) => payload, (payload, meta) => meta);
export const createBillScoutScheduleFailure = createAction('CREATE_BILLSCOUT_SCHEDULE_FAILURE');

// export const batchScheduledTransactions = createAction('BATCH_SCHEDULED_TRANSACTIONS');
// export const batchScheduledTransactionsSuccess = createAction('BATCH_SCHEDULED_TRANSACTIONS_SUCCESS');
// export const batchScheduledTransactionsFailure = createAction('BATCH_SCHEDULED_TRANSACTIONS_FAILURE');
